import {FocusElementState} from "../../interfaces/store/reducers/focusElement";
import {SetFocusedElementAction} from "../../interfaces/store/actions/focusElement";
import {SET_FOCUSED_ELEMENT} from "../actions/availableActions";

const initialState: FocusElementState = {
    focusedElement: null,
};

type AvailableActions = SetFocusedElementAction;

const focusElementReducer = (state: FocusElementState = initialState, action: AvailableActions): FocusElementState => {
    switch (action.type) {
        case SET_FOCUSED_ELEMENT:
            return {
                ...state,
                focusedElement: action.payload,
            };
        default:
            return state;
    }
};
export default focusElementReducer;
